import React    from 'react';
import ReactDom from 'react-dom';
import Moment   from 'moment';

import Const    from 'fw_const';
import Utils    from 'utils';

// -------------------------------------------------------


class ProgressTracker extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    let select = (this.props.select);
    try { if( select == undefined || select == '' || select == null ) select = this.props.tabs[0].id; } catch(e) {}
    
    try {
      let check = false;
      this.props.tabs.map((d) => { if( d.id == select ) check = true; });
      if( check == false ) select = this.props.tabs[0].id;
    } catch(e) {}
    
    this.state = {
      select: select,
    };
  }
  // -------------------------------------------------------
  
  componentWillReceiveProps(props) {
    if( props.direct_change === true ){
      try { if( props.select != undefined && this.state.select != props.select ) this.change.bind(this)(props.select); } catch(e) {}
    }
  }
  // -------------------------------------------------------
  
  /*
   * タブ変更
   */
  change(id) {
    this.setState({ select: id });
    
    // イベント設定時にはイベント起動
    try {
      if( this.props.update_ev != undefined ) this.props.update_ev.bind(this)(id);
      if( this.props.change_ev != undefined ) this.props.change_ev.bind(this)(id);
    } catch(e) {}
    
    // タブ切り替え時にサムネイルが取得できない問題の解決
    let y = window.pageYOffset
    scrollTo(0, (y + 1));
    scrollTo(0, (y - 1));
    scrollTo(0, y);
  }
  // -------------------------------------------------------
  
  render() {
    let select_tab = this.state.select;
    if( this.props.select_parent != undefined ) select_tab = this.props.select_parent;
    
    // タブの調整
    let temp_tab = '';
    this.props.tabs.map((d, key) => { if( d.deactive !== true && temp_tab == '' ) temp_tab = d.id; });
    this.props.tabs.map((d, key) => { if( d.deactive === true && d.id == select_tab ) select_tab = temp_tab; });
    
    // フォントサイズ
    let font_size = this.props.font_size;
    if( font_size == undefined ) font_size = 14;
    
    // 表示する画面
    let viewHtml = null;
    this.props.tabs.map((d) => { if( d.id == select_tab ) viewHtml = d.html; });
    
    // 表示形式指定
    let mode = this.props.mode;
    if( mode == undefined ) mode = 'alpha';
    
    // クラス名設定
    let mainClass = 'contents-tab';
    if( this.props.className != undefined ) mainClass = this.props.className;
    
    // タブの表示
    let tab_html = <div className="contents-tab-html">{viewHtml}</div>;
    if( mode == 'alpha' || mode == 'off-screen' ){
      tab_html = (
        <div className="contents-tab-html">
          { this.props.tabs.map((d, key) => {
            let flg = (d.id == select_tab) ? 'show' : 'hide';
            if( flg == 'hide' && mode == 'off-screen' ) flg = 'off-screen';
            
            return <div key={key} className={flg}>{d.html}</div>
          })}
        </div>
      );
    }
    
    return (
      <div id="contents-tab" className={mainClass}>
        
        <ul className={'size_'+ this.props.tabs.length +' '+ mainClass}>
          { this.props.tabs.map((d, key) => {
            let flg = (d.id == select_tab) ? 'on' : 'off';
            
            if( d.deactive === true ){
              return (
                <li key={key} className="deactive"><h4 style={{ fontSize: font_size }}>{d.name}</h4></li>
              );
            }
            
            let pop_count = (d.pop_count == undefined) ? 0 : d.pop_count;
            if( pop_count > 99 ) pop_count = 99;
            
            return (
              <li key={key} className={'c-tab-'+ d.id +' '+ flg} onClick={this.change.bind(this, d.id)}>
                <h4 style={{ fontSize: font_size }}>{d.name}
                  {(d.pop_mark === true) && <span className="pop-mark" /> }
                  {(pop_count > 0) && <span className="pop-count">{pop_count}</span> }
                </h4>
              </li>
            );
          })}
        </ul>
        
        {tab_html}
        
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProgressTracker;